import * as yup from 'yup';

export const schema = yup.object({
  username: yup.string().email('Enter a email').required('Email is required'),
  password: yup.string().required('Password is required'),
});
